import queryString from 'querystring';

const isFilterCategory = category =>
  /^s/.test(category.id) || category.filterId !== null;

const getFAQStructuredData = (market, category) => {
  return (
    // Only render for main Laptop category in SE
    market.code === 'se' &&
    !category.brand &&
    !isFilterCategory(category) &&
    String(category.id) === '353' && {
      '@context': 'http://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Vad ska jag tänka på när jag köper en bärbar dator?',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              '<p>Tänk på att inte köpa en alltför billig modell. Bärbara datorer kan sällan uppgraderas och skaffar du en budgetmodell med låg prestanda kan du bli besviken efter en tids användning. Prova datorn innan du köper den. Då kan du testa styrplattan och tangentbordet så att de har rätt känsla för dig, och även kolla om skärmen motsvarar dina behov. 8GB RAM-minne och 256GB hårddisk bör vara minimum om det är en Windows- eller Mac-dator. Kolla antalet portar och det bör finnas minst en eller två Thunderbolt 3-portar.</p><p><a href="https://www.prisjakt.nu/kategori.php?k=s423604679&catId=353">Här är alla bärbara datorer med 256GB lagring och mer</a>.</p>',
          },
        },
        {
          '@type': 'Question',
          name: 'Är bärbar dator bättre än en surfplatta?',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              '<p>Det beror på hur du vill arbeta. Det finns bärbara dator kan ha pekskärm som kan svängas 180 grader. Då blir den som en lite större surfplatta, men kan samtidigt användas som en vanlig bärbar dator med tangentbord om du vill. Det är generellt enklare att arbeta med en bärbar dator om du inte behöver en styluspenna, pekskärm den supertunna profilen i surfplattan.</p><p><a href="https://www.prisjakt.nu/kategori.php?k=1594">Här hittar du alla surfplattor på Prisjakt</a>.</p>',
          },
        },
        {
          '@type': 'Question',
          name: 'Hur mycket RAM-minne ska min bärbara dator ha?',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              '<p>Rekommendationen är att ha minst 8GB RAM-minne i bärbara datorn, gärna det dubbla om möjligt. Många nyare bärbara datorer stöder inte uppgradering i efterhand, så det gäller att välja rätt från början. Här är några generella råd kring mängden:</p><ul><li><strong>~4GB:</strong> Budgetmängd som är mest vanligt i de billigaste Windows-modellerna samt Chromebooks. Undvik 4GB eller lägre om du väljer en Windows- eller Mac-dator. Det är helt enkelt för lite och kan bli en begränsning längre fram om datorn inte kan uppgraderas med mer.</li><li><strong>8GB:</strong> Normalmängden som finns i de flesta bärbara datorer med Windows eller macOS. Fungerar utmärkt för många, men för krävande arbete kan det vara för lite.</li><li><strong>16GB:</strong> Bra mängd RAM-minne för gaming och krävande arbeten exempelvis med bild och video. Är mer framtidssäkert än 8GB, men också mycket dyrare i bärbara datorer.</li><li><strong>32GB+:</strong> För entusiaster och speciella situationer där stora mängder RAM-minne är nödvändigt, exempelvis i servrar eller andra specifika användningsområden.</li></ul><p>Här hittar du bärbara datorer med&nbsp;<a href="https://www.prisjakt.nu/kategori.php?k=v3276">8GB RAM</a>&nbsp;samt&nbsp;<a href="https://www.prisjakt.nu/kategori.php?k=v3277">16GB RAM</a>.</p>',
          },
        },
        {
          '@type': 'Question',
          name: 'Är gaming laptops prisvärda?',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              '<p>En bärbar gamingdator är praktisk att ta med på gående fot och det finns riktigt kraftfulla modeller som klarar även de mest krävande spelen. Men tänk på att en bärbar gamingdator generellt kostar betydligt mer än en likvärdig, stationär dator. Du kan inte byta processor eller grafikkort, men ibland finns möjlighet att uppgradera RAM-minnen och hårddisk. Stationära datorer håller normalt längre eftersom du kan byta alla delar i den medan bärbara datorer är betydligt mer låsta till vad du initialt köpte.</p><p>Här är&nbsp;<a href="https://www.prisjakt.nu/kategori.php?k=v3246">alla bärbara gamingdatorer</a>&nbsp;och här&nbsp;<a href="https://www.prisjakt.nu/kategori.php?k=v2388">alla stationära gamingdatorer</a>&nbsp;på Prisjakt.</p>',
          },
        },
        {
          '@type': 'Question',
          name: 'Bärbara datorer på rea',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              '<p>Det finns alltid bra erbjudanden på bärbara datorer. Många butiker har bra kampanjerbjudanden med stora prissänkningar. På vår Daily Deals-sida hittar du mängder av bärbara datorer som nyligen prissänkts – ofta med flera tusenlappar.</p><p><a href="https://www.prisjakt.nu/tema/dagens-deals?category=353">Här hittar du alla prissänkta bärbara datorer på Prisjakt</a>.</p>',
          },
        },
      ],
    }
  );
};

const getParentPath = category =>
  category.path && category.path.length > 0
    ? category.path.slice(-1).pop().pathName
    : category.pathName;

const getPopularBrands = products => {
  const brandsAggregation = products.reduce((brands, product) => {
    if (!product.brand) {
      return brands;
    }

    const brand = product.brand.name;

    return Object.assign(brands, {
      [brand]: (brands[brand] || 0) + 1,
    });
  }, {});

  return Object.keys(brandsAggregation).sort(
    (a, b) => brandsAggregation[b] - brandsAggregation[a]
  );
};

const getUrlsForSEO = (domain, path, pageInfo) => {
  const currentOffset = pageInfo.offset || 0;
  const currentLimit = pageInfo.limit;

  const [pathName, query] = path.split('?');

  const qs = queryString.parse(query || {});

  const prevOffset = Math.max(0, currentOffset - currentLimit);
  const prevParams = {
    ...qs,
    ...(prevOffset > 0 ? { offset: prevOffset } : {}),
  };

  const nextParams = {
    ...qs,
    offset: currentOffset + currentLimit,
  };

  const canonicalParams = {
    ...qs,
    ...(currentOffset > 0 && { offset: currentOffset }),
  };
  const sortedCanonicalQuery = Object.keys(canonicalParams)
    .sort()
    .reduce((q, key) => ({ ...q, [key]: canonicalParams[key] }), {});

  return {
    prev:
      domain +
      pathName +
      (Object.keys(prevParams).length > 0
        ? `?${queryString.encode(prevParams)}`
        : ''),
    next:
      domain +
      pathName +
      (Object.keys(nextParams).length > 0
        ? `?${queryString.encode(nextParams)}`
        : ''),
    canonical:
      domain +
      pathName +
      (Object.keys(sortedCanonicalQuery).length > 0
        ? `?${queryString.encode(sortedCanonicalQuery)}`
        : ''),
  };
};

const addBrandToCategoryUrl = (category, url) => {
  if (!category.brand) {
    return url;
  }

  if (/[?&]k=/.test(url)) {
    return `${url}&t=${category.brand.id}`;
  }

  if (/--c/.test(url)) {
    const separator = url.indexOf('?') === -1 ? '?' : '&';
    return `${url}${separator}brand=${category.brand.id}`;
  }

  return url;
};

export default ({ data }, { market, t }) => {
  if (!data) {
    return {};
  }

  const { category } = data;

  if (!category) {
    return {};
  }

  const meta = {
    data: category.name,
    name: category.name,
  };

  const categoryNames = [
    category.name,
    ...(category.categories
      ? category.categories.nodes.map(c => c.name).slice(0, 3)
      : []),
  ].join(', ');
  const productCount = category.productCount;
  const popularBrands = getPopularBrands(category.products.nodes)
    .slice(0, 3)
    .join(', ');

  const description = t('meta', 'category.description', {
    categoryNames,
    productCount,
    popularBrands,
  });

  const openGraph = [
    {
      key: 'title',
      content: t('meta', 'category.og-title', {
        name: category.name,
      }),
    },
    { key: 'url', content: market.domain + category.pathName },
    { key: 'desc', content: description },
    { key: 'type', content: 'product.group' },
    { key: 'image', content: category.logo },
  ];

  const isFilter = isFilterCategory(category);
  const path = isFilter ? getParentPath(category) : category.pathName;

  // Will only use these values if its not a filtered result and we are viewing the leaf node in the category tree
  const { prev, canonical, next } =
    !isFilter && category.immediateProducts
      ? getUrlsForSEO(market.domain, path, category.products.pageInfo)
      : {};

  return {
    canonical: canonical || market.domain + path,
    next: category.products.pageInfo.hasNext && next,
    prev: category.products.pageInfo.hasPrevious && prev,
    thumbnail: category.logo,
    description,
    title: t('meta', 'category.title', meta),
    openGraph,
    breadcrumb: category.path,
    structuredData: [
      {
        '@context': 'http://schema.org',
        '@type': 'Thing',
        name: category.name,
        description,
        image: category.logo,
        url: market.domain + category.pathName,
      },
      getFAQStructuredData(market, category),
    ],
    android: category.pathName,
    ios: `/category/${category.id}`, // TODO: Semantic id when app can handle it
    hrefLang:
      category.hrefLang &&
      category.hrefLang.map(link => ({
        ...link,
        url: addBrandToCategoryUrl(category, link.url),
      })),
    botify: {
      page: 'category',
      category: category.id,
      parentCategory:
        category.path && category.path[category.path.length - 2]
          ? category.path[category.path.length - 2].id
          : null,
      mainCategory:
        category.path && category.path.length > 0 && category.path[0].id,
    },
  };
};
